export default __webpack_public_path__ + "static/image-officelite-coming-soon-a96315b7184991894bedcbfbfbd3c45f.png";